import { render, staticRenderFns } from "./CommonDepartmentFixedPhraseSelector.vue?vue&type=template&id=11cd82c6&scoped=true&"
import script from "./CommonDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./CommonDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDepartmentFixedPhraseSelector.vue?vue&type=style&index=0&id=11cd82c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cd82c6",
  null
  
)

export default component.exports